import { Formik } from "formik";
import React, { useState } from "react";
import { Modal, Spinner, Form } from "react-bootstrap";
import InputText from "../../../../components/common/InputText";
import { recommendationSchema } from "../../../../validations/Deficiency";
import { RecommendationProps } from "./interface";
import { toast } from "react-toastify";
import {
  addDeficiencyAPI,
  updateDeficiencyAPI,
} from "../../../../services/deficiency";
function Recommendation(props: RecommendationProps) {
  const {
    showDeficiency,
    handleDeficiencyModelClose,
    machine_id,
    deficiencyDataObject,
    setChangesState,
    changesState,
    type,
    modelTitle,
  } = props;
  const [btnLoading, setBtnLoading] = useState(false);

  const handleSubmit = (values) => {
    setBtnLoading(true);
    const formData = {
      ...values,
      type,
    };

    if (deficiencyDataObject?.id) {
      const id = deficiencyDataObject.id;
      updateDeficiencyAPI(id, formData)
        .then((response) => {
          handleDeficiencyModelClose();
          setBtnLoading(false);
          setChangesState(!changesState);
          toast.success(response.message);
        })
        .catch((error) => {
          setBtnLoading(false);
          toast.error('Title already exist');
        });
    } else {
      addDeficiencyAPI(formData)
        .then((response) => {
          handleDeficiencyModelClose();
          setBtnLoading(false);
          setChangesState(!changesState);
          toast.success(response.message);
        })
        .catch((error) => {
          setBtnLoading(false);
          toast.error('Title already exist');
        });
    }
  };
  return (
    <div>
      <Modal
        show={showDeficiency}
        onHide={handleDeficiencyModelClose}
        centered
        dialogClassName="modal-350w">
        <Modal.Header closeButton className="">
          <Modal.Title className="fs-17 fw-semibold">{modelTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={recommendationSchema}
            initialValues={{
              title: deficiencyDataObject?.title
                ? deficiencyDataObject?.title
                : "",
              machine_id: machine_id,
            }}
            onSubmit={handleSubmit}>
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <Form className="" noValidate onSubmit={handleSubmit}>
                <InputText
                  controlId="title"
                  label="Description"
                  placeholder="Description"
                  touched={touched.title}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  errorsField={errors.title}
                  value={values.title}
                />

                <div className="d-flex">

                  {btnLoading ? (
                    <button
                      className="fs-13 fw-semibold text-black me-3  btn btn-primary"
                      type="submit">
                      <Spinner size="sm" />
                    </button>
                  ) : (
                    <button className="fs-13 fw-semibold text-black me-3  btn btn-primary">
                      Submit
                    </button>
                  )}
                  <button
                    type="reset"
                    className="me-2 fs-13 fw-semibold  btn btn-secondary"
                    onClick={handleDeficiencyModelClose}>
                    Close
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Recommendation;
